// Libs
import React, { HTMLProps, ReactElement } from 'react';
import clsx from 'clsx';
// App
import styles from './content-card-header.module.scss';

/**
 * Header for content card
 * Designed to be used with content card image and content card main information as children
 * @param props the props
 */
const ContentCardHeader = (props: HTMLProps<HTMLDivElement>): ReactElement => (
  <div {...props} className={clsx(styles.container, props.className)} />
);

export default ContentCardHeader;
